import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Alert, Grid, IconButton, Tooltip } from "@mui/material";
import { useState } from "react";
import { UseFormReturn } from "react-hook-form";

import {
  ESTADOS_LLAMADAS_CHOICE,
  EstadosLlamadaEnumChoice,
  gridSizeConst12,
  gridSizeMdLg12,
  gridSizeMdLg6
} from "@/shared";
import {
  CustomAutocomplete,
  CustomAutocompleteArrString,
  CustomNote,
  CustomTextArea,
  CustomTextField,
  CustomTextFieldNoForm,
  SampleCheckbox,
  SampleDatePicker,
  SingleButton,
  TabTexLabelCustomSpace,
  TabTextLabel,
} from "@/shared/components/ui";
import CustomCellphoneTextField from "@/shared/components/ui/CustomCellphoneTextField";
import { Flota } from "@/shared/interfaces";
import { TooltipIconEdit } from "@/erp/sale";
import { SaveFormDataPreagendamiento } from "@/erp/operaciones/preagendamiento/shared/interface/SaveFormDataPreagendamiento";
import TimeClockComponenteFlota from "@/erp/mantenimiento-operacion/flotas/shared/components/TimeClockComponenteFlota/TimeClockComponenteFlota";
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import { IPreagendamientoPymes } from "@/shared/interfaces/erp/ventas_pymes/preagendamiento_pymes.interface";
import CustomCoordendasForm from "@/erp/venta-corporativa/preventa_corporativo/shared/form_coordenadas/CustomCoordendasForm";
import ServiceAndOthersPartPreagendamientoPymesForm from "../serviceother_preagendamiento_sp/ServiceAndOthersPartPreagendamientoPymesForm";
import CustomAutocompleteFetchForm from "@/shared/components/ui/CustomAutocompleteFetchForm";
import useAutocompleteFetch from "@/shared/hooks/useAutocompleteFetch";

export type PreagendamientoSingleSoportePymesProps = {
  form: UseFormReturn<SaveFormDataPreagendamiento>;
  shrink?: boolean;
  preagendamiento: IPreagendamientoPymes;
  isCorrectingData?: boolean;
};

const PreagendamientoSingleSoportePymes: React.FC<PreagendamientoSingleSoportePymesProps> = ({
  form,
  shrink = true,
  isCorrectingData = false,
  preagendamiento,
}) => {
  ///* form --------------------
  //const { errors } = form?.formState;
  const {
    reset,
    formState: {
      errors
    }
  } = form

  ///* constants --------------------
  const [canViewDatosServicio, setCanViewDatosServicio] =
    useState<boolean>(false);

  /* const {
    //flotas, 
    isLoadingFlotas,
    flotaAdicional: flotaAadicional
  } = useFlotasStore(); */


  /*********** Handlers */
  const onResetHoraFechaInstlacion = async () => {
    form.reset({
      ...form.getValues(),
      flota: '',
      hora_instalacion: preagendamiento.hora_instalacion,
      fecha_instalacion: preagendamiento.fecha_instalacion
    });


  };

  const {
    fetchAutocompleteFlota
  } = useAutocompleteFetch()

  return (
    <Grid item container spacing={3}>

      <TabTextLabel text="Datos Cliente" />

      {/* =========== personal info =========== */}

      <CustomTextField
        name="tipo_identificacion"
        label="Tipo de Identificación"
        control={form.control}
        defaultValue={form.getValues().tipo_identificacion || ""}
        error={errors.tipo_identificacion}
        helperText={errors.tipo_identificacion?.message?.toString() ?? ""}
        shrink={shrink}
        size={gridSizeMdLg6}
        disabled
      />
      <CustomTextField
        name="identificacion"
        label="No. Identificación"
        control={form.control}
        defaultValue={form.getValues().identificacion || ""}
        error={errors.identificacion}
        helperText={errors.identificacion?.message?.toString() ?? ""}
        shrink={shrink}
        size={gridSizeMdLg6}
        disabled
      />
      <CustomTextField
        name="razon_social"
        label="Razon Social"
        control={form.control}
        defaultValue={form.getValues().razon_social || ""}
        error={errors.razon_social}
        helperText={errors.razon_social?.message?.toString() ?? ""}
        shrink={shrink}
        disabled
      />

      <CustomTextFieldNoForm
        label="Nombre de Enlace"
        defaultValue={form.getValues().nombre_enlace || ""}
        value={form.getValues().nombre_enlace || ""}
        size={gridSizeMdLg12}
        disabled
      />

      <TabTextLabel text="Representante Legal" />

      <CustomTextFieldNoForm
        label="Tipo Identificacion"
        defaultValue={form.getValues().representante_legal_tipo_identificacion || ""}
        value={form.getValues().representante_legal_tipo_identificacion || ""}
        shrink={shrink}
        size={gridSizeMdLg6}
        disabled
      />

      <CustomTextFieldNoForm
        label="Identificacion"
        defaultValue={form.getValues().representante_legal_identificacion || ""}
        value={form.getValues().representante_legal_identificacion || ""}
        shrink={shrink}
        size={gridSizeMdLg6}
        disabled
      />

      <CustomTextFieldNoForm
        label="Razon Social"
        defaultValue={form.getValues().representante_legal_razon_social || ""}
        value={form.getValues().representante_legal_razon_social || ""}
        shrink={shrink}
        size={gridSizeMdLg12}
        disabled
      />



      {/* =========== estado llamada =========== */}
      <TabTextLabel text="Estado de la llamada" pt={2} />

      <CustomCellphoneTextField
        endAdornmentInput={<TooltipIconEdit />}
        name="celular"
        label="Telefono Servicio"
        control={form.control}
        defaultValue={form.getValues().celular || ""}
        error={errors.celular}
        helperText={errors.celular?.message}
        //shrink={shrink}
        size={gridSizeMdLg6}
        disabled={isCorrectingData}
      />

      <CustomCellphoneTextField
        required={false}
        endAdornmentInput={<TooltipIconEdit />}
        name="representante_celular1"
        label="Celular Representante Legal"
        control={form.control}
        defaultValue={form.getValues().representante_celular1 || ""}
        error={errors.representante_celular1}
        helperText={errors.representante_celular1?.message}
        //shrink={shrink}
        size={gridSizeMdLg6}
        disabled={isCorrectingData}
      />
      <CustomCellphoneTextField
        endAdornmentInput={<TooltipIconEdit />}
        required={false}
        name="representante_celular2"
        label="Celular Adicional"
        control={form.control}
        defaultValue={form.getValues().representante_celular2 || "N/A"}
        error={errors.representante_celular2}
        helperText={errors.representante_celular2?.message}
        //shrink={shrink}
        size={gridSizeMdLg6}
        disabled={isCorrectingData}
      />
      {/* --------- estado llamada --------- */}
      <CustomAutocompleteArrString
        label="Estado de la llamada"
        name="estado_llamada"
        control={form.control}
        defaultValue={form.getValues().estado_llamada || ""}
        options={ESTADOS_LLAMADAS_CHOICE.filter(
          (el) => el !== EstadosLlamadaEnumChoice.EN_ESPERA
        )}
        isLoadingData={false}
        error={errors.estado_llamada}
        helperText={errors.estado_llamada?.message}
        disableClearable
        disabled={isCorrectingData}
      />
      <CustomTextArea
        label="Observación Llamada"
        name="observacion_llamada"
        control={form.control}
        defaultValue={
          form.getValues()?.observaciones?.observacion_llamada || ""
        }
        error={errors.observacion_llamada}
        helperText={errors.observacion_llamada?.message}
        required={false}
      />


      <TabTextLabel text="Ubicación" pt={2} />

      <CustomTextFieldNoForm
        label="Nombre Enlace"
        size={gridSizeMdLg12}
        value={form.getValues().nombre_enlace}
        defaultValue={form.getValues().nombre_enlace}
        disabled
        shrink
      />

      <CustomTextFieldNoForm
        label="Dirección"
        size={gridSizeMdLg12}
        value={form.getValues().direccion}
        defaultValue={form.getValues().direccion}
        disabled
        shrink
      />

      <CustomCoordendasForm
        size={gridSizeConst12}
        //key={field.id}
        label={`Coordenada`}
        defaultValue={form.getValues().coordenadas}
        name={'coordenadas'}
        form={form}
        onlyValueLocation={true}
        disabled={true}
        canLocationSearch={false}
        canDragMarker={false}
      />

      {/* <UbicacionPreagendamiento
        form={form}
        preagendamiento={preagendamiento}
        errors={errors}
      /> */}

      <Grid item {...gridSizeMdLg12}>
        <TabTextLabel text="FECHA Y HORA SUGERIDA POR EL ASESOR" pb={0} pl={0} />
      </Grid>

      <CustomTextFieldNoForm
        label="Fecha instalación"
        defaultValue={preagendamiento.fecha_instalacion || ""}
        value={preagendamiento.fecha_instalacion || ""}
        shrink={shrink}
        size={gridSizeMdLg6}
        disabled
      />

      <CustomTextFieldNoForm
        label="Hora instalación"
        defaultValue={preagendamiento.hora_instalacion || ""}
        value={preagendamiento.hora_instalacion || ""}
        shrink={shrink}
        size={gridSizeMdLg6}
        disabled
      />

      <Grid item container xs={12} justifyContent={'space-between'}>
        <Grid item >
          <TabTextLabel text="SELECCIONAR TECNICO" pb={0} pl={0} />
        </Grid>
        <Grid item>
          <IconButton
            color="primary"
            onClick={() => onResetHoraFechaInstlacion()}
          >
            <Tooltip placement="top" title='Resetear fecha y hora de instalación'>
              <RestartAltIcon />
            </Tooltip>
          </IconButton>
        </Grid>
      </Grid>




      {/* {
        !preagendamiento.flota_adicional && (
          <CustomAutocomplete<Flota>
            disabled={false}
            size={gridSizeMdLg12}
            label={'Técnicos Disponibles'}
            name="flota"
            options={flotas || []}
            valueKey="nombre"
            actualValueKey="codigo"
            defaultValue={form.getValues().flota}
            isLoadingData={isLoadingFlotas}
            control={form.control}
            error={errors.flota}
            helperText={errors.flota?.message}
            onChangeValue={(e) => {
              form.setValue('flota', e)
            }}
          />
        )
      } */}

      {
        !preagendamiento.flota_adicional && (
          <CustomAutocompleteFetchForm<Flota>
            control={form.control}
            required={false}
            size={gridSizeMdLg12}
            name="flota"
            label="Técnico"
            fetchParams={{
              es_pyme: true,
              es_corporativo: true,
            }}
            isAll={false}
            fetchData={fetchAutocompleteFlota} ///* TODO: Pendiente revisar
            getOptionLabel={(opt) => `${opt.nombre}` || ''}
            key={'flota-producto'}

            getOptionKey={(opt) => opt.codigo}
            //getValue={(opt) => opt.codigo}
            //valueKey="codigo"
            onChangeValue={(e) => {
              form.setValue('flota', e as string)

            }}
          />
        )
      }

      {
        preagendamiento.flota_adicional
        && preagendamiento.flota_adicional_data && (
          <>
            <CustomAutocomplete<Flota>
              disabled={false}
              size={gridSizeMdLg12}
              label={'Técnico Solicitado'}
              name="flota"
              options={[preagendamiento.flota_adicional_data]}
              valueKey="nombre"
              actualValueKey="codigo"
              defaultValue={form.getValues().flota}
              isLoadingData={false}
              control={form.control}
              error={errors.flota}
              helperText={errors.flota?.message}
              onChangeValue={(e) => {
                form.setValue('flota', e)
              }}
            />
            <Grid item {...gridSizeMdLg12}>
              <Alert variant="outlined" severity="success">
                El departamento correspondiente ha aprobado la solicitud del técnico adicional.
              </Alert>
            </Grid>

          </>
        )
      }

      {/*  && preagendamiento.observaciones.observacion_cancelacion_tecnico  */}

      {preagendamiento.observaciones != null && preagendamiento.observaciones.observacion_cancelacion_tecnico && (
        <Grid item {...gridSizeMdLg12}>
          <Alert variant="outlined" severity="info">
            {`ESTADO DE SOLICITUD TECNICO: ${preagendamiento.observaciones.observacion_cancelacion_tecnico}`}
          </Alert>
        </Grid>
      )


      }
      <SampleDatePicker
        minDate={new Date}
        label="Fecha de instalación"
        control={form.control}
        error={errors.fecha_instalacion}
        helperText={errors.fecha_instalacion?.message}
        name="fecha_instalacion"
        textFieldKey="fecha_instalacion"
        defaultValue={null}
        size={gridSizeMdLg6}
        onChangeRawValue={(e) => {
          form.setValue('fecha_tecnico_adicional', e)
        }}
      />

      <TimeClockComponenteFlota
        size={gridSizeMdLg6}
        control={form.control}
        error={errors.hora_instalacion}
        helperText={errors.hora_instalacion?.message}
        label='Hora de instalación'
        name='hora_instalacion'
        defaultValue={form.getValues().hora_instalacion}
        format="hh:mm A"
        enableDateTypeResult={true}
        onChangeValue={(e) => {
          form.setValue('hora_tecnico_adicional', e)

        }}
      />

      <SampleCheckbox
        label="Solicitar tecnico para la instalación."
        name="solicitar_tecnico"
        control={form.control}
        defaultValue={form.getValues().solicitar_tecnico || false}
        size={gridSizeMdLg12}
        onChangeValue={(e) => {
          reset({
            ...form.getValues(),
            flota: '',
            solicitar_tecnico: e,
            observacion_tecnico_adicional: `Solicito técnico para la fecha ${form.getValues().fecha_instalacion} y hora ${form.getValues().hora_instalacion}, contactar en el sitio a [Nombre del contacto] al [celular].`
          })
        }}
      />

      {
        form.getValues().solicitar_tecnico && (
          <>
            <TabTextLabel text="Solicitud técnico" pb={1} />

            {/* <TabTextLabel text="Fecha y hora de solicitud para tecnico" pb={0} />
            <SampleDatePicker
              disabled
              minDate={new Date}
              label="Fecha Técnico"
              control={form.control}
              error={errors.fecha_tecnico_adicional}
              helperText={errors.fecha_tecnico_adicional?.message}
              name="fecha_tecnico_adicional"
              textFieldKey="fecha_tecnico_adicional"
              defaultValue={null}
              size={gridSizeMdLg6}
            />

            <TimeClockComponenteFlota
              disabled
              size={gridSizeMdLg6}
              control={form.control}
              error={errors.hora_tecnico_adicional}
              helperText={errors.hora_tecnico_adicional?.message}
              label='Hora Técnico'
              name='hora_tecnico_adicional'
              defaultValue={form.getValues().hora_tecnico_adicional}
              format="hh:mm A"
              enableDateTypeResult={true}
            /> */}

            <CustomTextArea
              type="none"
              label="Observación Solicitud Técnico"
              name="observacion_tecnico_adicional"
              rows={5}
              control={form.control}
              defaultValue={preagendamiento.observaciones?.observacion_tecnico_adicional ?? 'N/A'}
              error={errors.observacion_tecnico_adicional}
              helperText={errors.observacion_tecnico_adicional?.message}
              required={true}
            />

            <CustomNote
              note={`Nota: Al solicitar un técnico, el proceso de agendamiento quedará en PENDIENTE hasta que la solicitud sea aprobada por el departamento correspondiente.`}
            />
          </>

        )
      }

      {/* ================ Service ================ */}
      {preagendamiento?.nap && (
        <TabTexLabelCustomSpace
          textContent="Datos de Servicio"
          showCustomRightSpace={true}
          customRightSpace={
            <SingleButton
              newCustomButton
              startIcon={
                canViewDatosServicio ? <ExpandLessIcon /> : <ExpandMoreIcon />
              }
              label={canViewDatosServicio ? "OCULTAR" : "VER MÁS"}
              variant="text"
              onClick={() => {
                setCanViewDatosServicio((prev) => !prev);
              }}
            />
          }
        />
      )}
      {canViewDatosServicio && (
        <ServiceAndOthersPartPreagendamientoPymesForm
          form={form}
          preagendamiento={preagendamiento}
          isCorrectingData={isCorrectingData}
        />
      )}
    </Grid>
  );
};
export default PreagendamientoSingleSoportePymes;
